import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './layouts/Header';
import Footer from './layouts/Footer';
import Home from './pages/Home';
import About from './pages/About';
import VotingSystems from './pages/VotingSystems';
import VotingSimulator from './pages/VotingSimulator';
import GetInvolved from './pages/GetInvolved';
import OurReforms from './pages/OurReforms';
import FAQs from './pages/FAQs';
import ContactUs from './pages/ContactUs';
import Media from './pages/Media';
import RankTheBlank from './pages/RankTheBlank';
import './App.css';

const App = () => {
  return (
    <Router>
      <div className="app">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/voting-systems" element={<VotingSystems />} />
            <Route path="/simulator" element={<VotingSimulator />} />
            <Route path="/get-involved" element={<GetInvolved />} />
            <Route path="/demands" element={<OurReforms />} />
            <Route path="/faq" element={<FAQs />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/media" element={<Media />} />
            <Route path="/rank-the-blank" element={<RankTheBlank />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

// NotFound component for 404 pages
const NotFound = () => (
  <div className="container page-container">
    <h1>404 - Page Not Found</h1>
    <p>The page you are looking for does not exist.</p>
  </div>
);

export default App;